import { getNewsPage,NewsVO } from "@/api/cms"
import { defineStore } from "pinia"

const useRegion = useRegionStore()
// 配置：自动刷新间隔（毫秒）
const AUTO_REFRESH_INTERVAL = 10000

export const useKnowledgeStore = defineStore('info', () => {
  const list = ref<NewsVO[]>([])
  const refreshTrigger = ref(0)
  let autoRefreshTimer: ReturnType<typeof setInterval> | null = null


    // 停止自动刷新
  const stopAutoRefresh = () => {
    if (autoRefreshTimer) {
      clearInterval(autoRefreshTimer)
      autoRefreshTimer = null
    }
  }
   // 启动自动刷新
  const startAutoRefresh = () => {
    autoRefreshTimer = setInterval(() => {
      refreshTrigger.value++
    }, AUTO_REFRESH_INTERVAL)
  }

  async function fetchInfoList() {
    const res = await getNewsPage({ pageNo: 1, pageSize: 100, newsType: 2 ,regionIdList:[0,useRegion.currentRegion.regionId]})
    list.value = res.list
    // 获取数据后启动自动刷新
    stopAutoRefresh();
    startAutoRefresh();
  }

  // 随机抽取 1 条
  function getRandomOne() {
    // 触发依赖，让调用方能够响应刷新
    refreshTrigger.value
    
    if (list.value.length === 0) 
      return {
        title: '长协锁价实操',
        summary: '售电公司与发电企业签订年度 / 月度长协，约定固定电价锁定基础电量，剩余少量电量参与现货，以此平抑价格波动、控制购电成本。',
        content: ''
      }
    const randomIndex = Math.floor(Math.random() * list.value.length)
    return list.value[randomIndex] as NewsVO
  }

  return {
    list,
    fetchInfoList,
    getRandomOne
  }
})